import { DatePipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { utils, writeFile } from 'xlsx';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Historial } from 'src/app/shared/model/empleado/historial.model';
import { EmpleadoService } from '../empleado.service';

@Component({
  selector: 'app-HistorialSolser',
  standalone: true,
  templateUrl: './HistorialSolser.component.html',
  styleUrl: './HistorialSolser.component.css',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatTooltipModule,
    NgFor,
    NgIf,
    DatePipe,
  ],
  providers: [DatePipe],
})
export class HistorialSolserComponent implements OnInit {
  formFiltros = new FormGroup({
    nombreEmpleado: new FormControl(''),
    fechaFiltro: new FormControl(''),
  });

  HistorialEmpl: Historial[] = [];
  consObjHist = new ConsultaList<Historial>();
  totalRegistrosH = 0;
  pageSize = 50;
  readonly pageSizeOptions = [10, 20, 50];
  currentPage = 1;
  loading = false;
  Fechad = new Date().toISOString();
  fech = '';
  pruebaF = '';
  dia!: string;
  mes!: string;
  ac!: string;
  diaN!: number;
  mesN!: number;
  acN!: number;
  fechaC = '';
  tittleD = '';
  mensajeD = '';
  aux: any[] = [];

  constructor(
    private empleadoService: EmpleadoService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.consObjHist.bean = new Historial();
    this.consObjHist.bean.fecha_creacion = this.datePipe.transform(this.Fechad, 'yyy-MM-dd') || '';
    this.Fechad = this.datePipe.transform(this.Fechad, 'dd-MM-yyyy') || '';
    this.tittleD = 'Descargar Registro de Acceso ' + this.Fechad;

    this.formFiltros.get('nombreEmpleado')?.valueChanges.subscribe((nombre) => {
      this.consObjHist.bean.nombre = nombre ?? null;
      this.consultaPagina(1);
    });

    this.formFiltros.get('fechaFiltro')?.valueChanges.subscribe((fecha) => {
      if (fecha) {
        this.Fechad = this.datePipe.transform(fecha, 'dd-MM-yyyy') || this.Fechad;
        this.tittleD = 'Descargar Registro de Acceso ' + this.Fechad;
        this.fech = this.datePipe.transform(fecha, 'yyyy-MM-dd') || '';
        this.consObjHist.bean.fecha_creacion = this.fech;
        this.consultaPagina(1);
      }
    });

    this.consultaPagina(1);
  }

  get totalPages(): number {
    return this.totalRegistrosH > 0 ? Math.ceil(this.totalRegistrosH / this.pageSize) : 0;
  }

  get showPagination(): boolean {
    return this.totalRegistrosH > 0;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRegistrosH);
  }

  agregarHorasHistorial(): void {
    this.empleadoService.consultaEmpleadosActivos().subscribe((res: any) => {
      const lista = res.list || [];

      const opcionesHtml = lista
        .map(
          (emp: any) => `
          <div style="display: flex; align-items: center; gap: 10px; padding: 10px; border-bottom: 1px solid #f0f0f0; transition: background 0.2s;"
              onmouseover="this.style.background='#f8f9fa'" onmouseout="this.style.background='transparent'">
            <input type="checkbox" class="empl-checkbox"
                  style="width: 18px; height: 18px; cursor: pointer;"
                  value="${emp.idEmpleado}"
                  data-huella="${emp.existeHuella}"
                  id="emp-${emp.idEmpleado}">
            <label for="emp-${emp.idEmpleado}" style="cursor: pointer; flex: 1; margin: 0; font-size: 14px; color: #333; text-align: left;">
              ${emp.persona.nombre} ${emp.persona.apellidoPaterno} ${emp.persona.apellidoMaterno}
            </label>
          </div>
        `
        )
        .join('');

      Swal.fire({
        title: 'Registro de Acceso',
        width: '850px',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Guardar Registros',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        html: `
          <div style="display: flex; flex-direction: column; gap: 15px; padding: 10px;">
            <div style="text-align: left;">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                <label style="font-weight: bold; color: #444; font-size: 16px;">Seleccione los Empleados:</label>
                <button type="button" id="btn-select-all"
                        style="cursor: pointer; background-color: #3085d6; color: white; border: none; border-radius: 20px; padding: 6px 15px; font-size: 13px; font-weight: 600; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                  <span id="text-select-all">Seleccionar Todos</span>
                </button>
              </div>

              <div id="checkbox-container" style="width: 100%; height: 280px; overflow-y: auto; border: 1px solid #d9d9d9; border-radius: 8px; background: white; box-shadow: inset 0 1px 3px rgba(0,0,0,0.05);">
                ${opcionesHtml}
              </div>
            </div>

            <div style="display: flex; gap: 20px; background: #f9f9f9; padding: 15px; border-radius: 8px;">
              <div style="flex: 1; text-align: left;">
                <label style="font-weight: bold; display: block; margin-bottom: 5px;">Hora de Entrada</label>
                <input type="datetime-local" id="entrada" class="swal2-input" style="width: 100%; margin: 0;">
              </div>
              <div style="flex: 1; text-align: left;">
                <label style="font-weight: bold; display: block; margin-bottom: 5px;">Hora de Salida</label>
                <input type="datetime-local" id="salida" class="swal2-input" style="width: 100%; margin: 0;">
              </div>
            </div>
          </div>
        `,
        didOpen: () => {
          const btnAll = document.getElementById('btn-select-all');
          const checkboxes = document.querySelectorAll('.empl-checkbox') as NodeListOf<HTMLInputElement>;

          btnAll?.addEventListener('click', () => {
            const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
            checkboxes.forEach((cb) => (cb.checked = !allChecked));
            const textNode = document.getElementById('text-select-all');
            if (textNode) {
              textNode.innerText = allChecked ? 'Seleccionar Todos' : 'Deseleccionar Todos';
            }
            (btnAll as HTMLButtonElement).style.backgroundColor = allChecked ? '#3085d6' : '#6e7881';
          });
        },
        preConfirm: () => {
          const checkedBoxes = document.querySelectorAll('.empl-checkbox:checked') as NodeListOf<HTMLInputElement>;
          const horaEntrada = (document.getElementById('entrada') as HTMLInputElement).value;
          const horaSalida = (document.getElementById('salida') as HTMLInputElement).value;

          if (checkedBoxes.length === 0) {
            Swal.showValidationMessage('Debe seleccionar al menos un empleado');
            return false;
          }
          if (!horaEntrada) {
            Swal.showValidationMessage('La hora de entrada es obligatoria');
            return false;
          }

          return Array.from(checkedBoxes).map((cb) => ({
            idEmpleado: cb.value,
            existeHuella: cb.getAttribute('data-huella'),
            entrada: horaEntrada,
            salida: horaSalida,
            ubicacion: 23,
          }));
        },
      }).then((result: any) => {
        if (result.isConfirmed) {
          const peticiones = result.value.map((data: any) => firstValueFrom(this.empleadoService.agregarSalidaEntrada(data)));

          void Promise.all(peticiones).then((respuestas: any[]) => {
            const exitosos = respuestas.filter((r) => r.pCodRetorno === '00000');
            const fallidos = respuestas.filter((r) => r.pCodRetorno !== '00000');
            this.consultaPagina(this.currentPage);

            if (fallidos.length > 0) {
              Swal.fire({
                title: 'Resumen del Proceso',
                icon: 'warning',
                html: `
                  <div style="text-align: left;">
                    <p style="color: green;"><b>${exitosos.length}</b> registrados con éxito.</p>
                    <p style="color: red;"><b>${fallidos.length}</b> no se pudieron registrar.</p>
                    <div style="margin-top: 10px; padding: 10px; background: #fff5f5; border: 1px solid #feb2b2; border-radius: 5px; max-height: 150px; overflow-y: auto;">
                      <small><b>Motivo:</b> Los empleados no cuentan con huella registrada en el sistema.</small>
                    </div>
                  </div>
                `,
              });
            } else {
              Swal.fire('Éxito', `Se registraron ${exitosos.length} empleados correctamente.`, 'success');
            }
          });
        }
      });
    });
  }

  editarEmpleadoHistorial(empleadoBean: Historial): void {
    const horaEntrada = this.datePipe.transform(empleadoBean.entrada, 'HH:mm');
    const horaSalida = this.datePipe.transform(empleadoBean.salida, 'HH:mm');

    Swal.fire({
      title: 'Editar Hora de Registro',
      showCloseButton: true,
      html: `
        <div style="display: flex; gap: 20px; justify-content: center; align-items: flex-start; padding: 10px;">
          <div class="swal-form-container" style="flex: 1;">
            <label for="entrada" style="display: block; font-weight: bold; margin-bottom: 8px; font-size: 14px;">Entrada</label>
            <input type="time" id="entrada" class="swal2-input" style="margin: 0; width: 100%;" value="${horaEntrada}">
          </div>

          <div class="swal-form-container" style="flex: 1;">
            <label for="salida" style="display: block; font-weight: bold; margin-bottom: 8px; font-size: 14px;">Salida</label>
            <input type="time" id="salida" class="swal2-input" style="margin: 0; width: 100%;" value="${horaSalida}">
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Guardar cambios',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
      preConfirm: () => {
        const horaSeleccionadaEntrada = (document.getElementById('entrada') as HTMLInputElement).value;
        const horaSeleccionadaSalida = (document.getElementById('salida') as HTMLInputElement).value;
        const partes = this.Fechad.split('-');
        const fechaISO = `${partes[2]}-${partes[1]}-${partes[0]}`;
        const entradaBD = `${fechaISO} ${horaSeleccionadaEntrada}:00`;
        const salidaBD = `${fechaISO} ${horaSeleccionadaSalida}:00`;
        return { entradaBD, salidaBD };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const empleadoActualizado = { ...empleadoBean, entrada: result.value.entradaBD, salida: result.value.salidaBD };
        this.ejecutarActualizacion(empleadoActualizado);
      }
    });
  }

  private ejecutarActualizacion(empleadoBean: Historial): void {
    if (empleadoBean.id != null && empleadoBean.id !== '') {
      this.empleadoService.editarSalidaEntrada(empleadoBean).subscribe({
        next: (res) => {
          if (res.pCodRetorno === '00000') {
            Swal.fire({
              title: 'Actualizado',
              text: res.pMensaje || 'El registro se actualizó correctamente.',
              icon: 'success',
              timer: 3000,
            });
            this.consultaPagina(this.currentPage);
          } else {
            Swal.fire('Error', 'No se pudo actualizar: ' + res.pMensaje, 'error');
          }
        },
        error: () => {
          Swal.fire('Error de conexión', 'Hubo un problema con el servidor', 'error');
        },
      });
      return;
    }

    Swal.fire('Error', 'El registro de acceso no tiene un identificador válido.', 'error');
  }

  consultaPagina(page: number): void {
    const targetPage = page && page > 0 ? page : 1;
    this.currentPage = targetPage;
    this.loading = this.HistorialEmpl.length === 0;
    this.cdr.detectChanges();

    this.consObjHist.regInicial = (targetPage - 1) * this.pageSize;
    this.consObjHist.regXPagina = this.pageSize;

    this.empleadoService.consultaEmpleadosHistorialSolser(this.consObjHist).subscribe({
      next: (res) => {
        this.HistorialEmpl = Array.isArray(res?.list) ? [...res.list] : [];
        this.totalRegistrosH = this.resolveTotalRegistros(res, this.HistorialEmpl);

        const maxPage = this.totalPages;
        if (this.totalRegistrosH > 0 && targetPage > maxPage) {
          this.consultaPagina(maxPage);
          return;
        }

        if (this.totalRegistrosH === 0) {
          this.currentPage = 1;
        }

        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.HistorialEmpl = [];
        this.totalRegistrosH = 0;
        this.currentPage = 1;
        this.loading = false;
        this.cdr.detectChanges();
      },
    });
  }

  limpiarFiltros(): void {
    this.consObjHist.bean.nombre = null;
    this.formFiltros.patchValue({ nombreEmpleado: '' }, { emitEvent: false });
    this.consultaPagina(1);
  }

  onPageSizeChange(value: number): void {
    this.pageSize = Number(value);
    this.consultaPagina(1);
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }

    this.consultaPagina(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);

    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === 'number';
  }

  diaAntes(): void {
    this.pruebaF = this.Fechad;
    this.dia = this.pruebaF.substring(0, 2);
    this.mes = this.pruebaF.substring(3, 5);
    this.ac = this.pruebaF.substring(6, 10);
    this.diaN = Number.parseInt('' + this.dia, 10);
    this.mesN = Number.parseInt('' + this.mes, 10);
    this.acN = Number.parseInt('' + this.ac, 10);
    if (this.diaN > 1) {
      if (this.diaN <= 10) {
        this.fechaC = '' + this.acN + '-' + this.mes + '-0' + (this.diaN - 1);
        this.Fechad = '0' + (this.diaN - 1) + '-' + this.mes + '-' + this.acN;
      } else {
        this.fechaC = '' + this.acN + '-' + this.mes + '-' + (this.diaN - 1);
        this.Fechad = '' + (this.diaN - 1) + '-' + this.mes + '-' + this.acN;
      }
    } else if (this.mesN > 1) {
      if (this.mesN == 3) {
        this.fechaC = '' + this.acN + '-0' + (this.mesN - 1) + '-' + (this.diaN = 28);
        this.Fechad = '' + (this.diaN = 28) + '-0' + (this.mesN - 1) + '-' + this.acN;
      } else if (this.mesN == 5 || this.mesN == 7 || this.mesN == 10 || this.mesN == 12) {
        if (this.mesN <= 10) {
          this.fechaC = '' + this.acN + '-0' + (this.mesN - 1) + '-' + (this.diaN = 30);
          this.Fechad = '' + (this.diaN = 30) + '-0' + (this.mesN - 1) + '-' + this.acN;
        } else {
          this.fechaC = '' + this.acN + '-' + (this.mesN - 1) + '-' + (this.diaN = 30);
          this.Fechad = '' + (this.diaN = 30) + '-' + (this.mesN - 1) + '-' + this.acN;
        }
      } else {
        if (this.mesN <= 10) {
          this.fechaC = '' + this.acN + '-0' + (this.mesN - 1) + '-' + (this.diaN = 31);
          this.Fechad = '' + (this.diaN = 31) + '-0' + (this.mesN - 1) + '-' + this.acN;
        } else {
          this.fechaC = '' + this.acN + '-' + (this.mesN - 1) + '-' + (this.diaN = 31);
          this.Fechad = '' + (this.diaN = 31) + '-' + (this.mesN - 1) + '-' + this.acN;
        }
      }
    } else {
      this.fechaC = '' + (this.acN - 1) + '-' + (this.mesN = 12) + '-' + (this.diaN = 31);
      this.Fechad = '' + (this.diaN = 31) + '-' + (this.mesN = 12) + '-' + (this.acN - 1);
    }
    this.tittleD = 'Descargar Registro de Acceso ' + this.Fechad;
    this.consObjHist.bean.fecha_creacion = this.fechaC;
    this.consultaPagina(1);
  }

  diaDespues(): void {
    this.pruebaF = this.Fechad;
    this.dia = this.pruebaF.substring(0, 2);
    this.mes = this.pruebaF.substring(3, 5);
    this.ac = this.pruebaF.substring(6, 10);
    this.diaN = Number.parseInt('' + this.dia, 10);
    this.mesN = Number.parseInt('' + this.mes, 10);
    this.acN = Number.parseInt('' + this.ac, 10);

    if ((this.diaN < 28 && this.mesN == 2) ||
        (this.diaN < 30 && this.mesN == 4) ||
        (this.diaN < 30 && this.mesN == 6) ||
        (this.diaN < 30 && this.mesN == 9) ||
        (this.diaN < 30 && this.mesN == 11) ||
        (this.diaN < 31 && this.mesN == 1) ||
        (this.diaN < 31 && this.mesN == 3) ||
        (this.diaN < 31 && this.mesN == 5) ||
        (this.diaN < 31 && this.mesN == 7) ||
        (this.diaN < 31 && this.mesN == 8) ||
        (this.diaN < 31 && this.mesN == 10) ||
        (this.diaN < 31 && this.mesN == 12)) {
      if (this.diaN <= 8) {
        this.fechaC = '' + this.acN + '-' + this.mes + '-0' + (this.diaN + 1);
        this.Fechad = '0' + (this.diaN + 1) + '-' + this.mes + '-' + this.acN;
      } else {
        this.fechaC = '' + this.acN + '-' + this.mes + '-' + (this.diaN + 1);
        this.Fechad = '' + (this.diaN + 1) + '-' + this.mes + '-' + this.acN;
      }
    } else if (this.mesN < 12) {
      if (this.mesN <= 8) {
        this.fechaC = '' + this.acN + '-0' + (this.mesN + 1) + '-0' + (this.diaN = 1);
        this.Fechad = '0' + (this.diaN = 1) + '-0' + (this.mesN + 1) + '-' + this.acN;
      } else {
        this.fechaC = '' + this.acN + '-' + (this.mesN + 1) + '-0' + (this.diaN = 1);
        this.Fechad = '0' + (this.diaN = 1) + '-' + (this.mesN + 1) + '-' + this.acN;
      }
    } else {
      this.fechaC = '' + (this.acN + 1) + '-0' + (this.mesN = 1) + '-0' + (this.diaN = 1);
      this.Fechad = '0' + (this.diaN = 1) + '-0' + (this.mesN = 1) + '-' + (this.acN + 1);
    }
    this.tittleD = 'Descargar Registro de Acceso ' + this.Fechad;
    this.consObjHist.bean.fecha_creacion = this.fechaC;
    this.consultaPagina(1);
  }

  exportAsXLSX(): void {
    this.empleadoService.descargarRegistro(this.consObjHist).subscribe((res) => {
      this.mensajeD = res.pMensaje;
    });
    this.aux = [];
    for (let i = 0; i < this.HistorialEmpl.length; i++) {
      this.aux.push({
        Numero: i + 1,
        Nombre: this.HistorialEmpl[i].nombre,
        Entrada: this.datePipe.transform(this.HistorialEmpl[i].entrada, 'h:mm a'),
        Salida: this.datePipe.transform(this.HistorialEmpl[i].salida, 'h:mm a'),
      });
    }
    const headings = [['Num.', 'Nombre', 'Entrada', 'Salida']];
    const wb = utils.book_new();
    const ws: any = utils.json_to_sheet([]);
    utils.sheet_add_aoa(ws, headings);
    utils.sheet_add_json(ws, this.aux, { origin: 'A2', skipHeader: true });
    utils.book_append_sheet(wb, ws, 'Registros de Acceso');
    writeFile(wb, 'Registros del ' + this.Fechad + '.xlsx');
  }

  private resolveTotalRegistros(res: ConsultaList<Historial>, historial: Historial[]): number {
    const response = res as ConsultaList<Historial> & Record<string, unknown>;
    const candidates = [response?.pTotalItems, response?.totalItems, response?.totalRegistros, response?.param4];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return Array.isArray(historial) ? historial.length : 0;
  }
}
